'use client';

import { useEffect } from 'react';

const AI_REFERRER_PATTERNS = [
  { pattern: 'chat.openai.com', source: 'chatgpt' },
  { pattern: 'chatgpt.com', source: 'chatgpt' },
  { pattern: 'gemini.google.com', source: 'gemini' },
  { pattern: 'perplexity.ai', source: 'perplexity' },
  { pattern: 'claude.ai', source: 'claude' },
  { pattern: 'copilot.microsoft.com', source: 'copilot' },
  { pattern: 'you.com', source: 'you_ai' },
  { pattern: 'phind.com', source: 'phind' },
  { pattern: 'poe.com', source: 'poe' },
] as const;

export function AIReferralTracker() {
  useEffect(() => {
    if (typeof window === 'undefined' || !window.dataLayer) return;

    const referrer = document.referrer;
    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get('utm_source')?.toLowerCase();

    // Check referrer URL
    if (referrer) {
      const match = AI_REFERRER_PATTERNS.find((p) => referrer.includes(p.pattern));
      if (match) {
        window.dataLayer.push({
          event: 'ai_referral',
          ai_source: match.source,
          ai_medium: 'ai_referral',
          referrer_url: referrer,
          landing_page: window.location.pathname,
          timestamp: new Date().toISOString(),
        });
        return;
      }
    }

    // Check UTM parameters
    if (utmSource && ['chatgpt', 'perplexity', 'gemini', 'claude', 'copilot'].includes(utmSource)) {
      window.dataLayer.push({
        event: 'ai_referral',
        ai_source: utmSource,
        ai_medium: 'ai_referral',
        referrer_url: referrer || '',
        landing_page: window.location.pathname,
        timestamp: new Date().toISOString(),
      });
    }
  }, []);

  return null;
}
